import { Routes } from '@angular/router';
import { MainLayout } from './layout/main-layout/main-layout';
import { AuthLayout } from './layout/auth-layout/auth-layout';
import { LandingLayout } from './layout/landing-layout/landing-layout';
import { authGuard } from './core/guards/auth-guard';

export const routes: Routes = [
  {
    path: 'auth',
    component: AuthLayout,
    children: [
      {
        path: 'login',
        loadComponent: () => import('./auth/login/login').then(m => m.Login)
      },
      {
        path: 'register',
        loadComponent: () => import('./auth/register/register').then(m => m.Register)
      },

      {
        path: 'email/:action',
        loadComponent: () => import('./auth/email-action-form/email-action-form').then(m => m.EmailActionForm)
      },
      {
        path: 'password/reset',
        loadComponent: () => import('./auth/reset-password-form/reset-password-form.component').then(m => m.ResetPasswordFormComponent)
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    component: MainLayout,
    children: [
      {
        path: '',
        loadComponent: () => import('./feature/marketing-page/marketing-page').then(m => m.MarketingPage)
      }
    ]
  },
  {
    path: 'resume/upload',
    component: MainLayout,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./feature/resume-manager/resume-manager').then(m => m.ResumeManagerComponent)
      }
    ]
  },

  // {
  //   path: 'jobs',
  //   component: MainLayout,
  //   children: [
  //     {
  //       path: '',
  //       loadComponent: () => import('./feature/job-board/job-board.component').then(m => m.JobBoardComponent)
  //     },
  //     {
  //       path: ':id',
  //       loadComponent: () => import('./feature/job-details/job-detail/job-detail').then(m => m.JobDetailComponent)
  //     }
  //   ]
  // },

  // {
  //   path: 'candidate-discovery',
  //   component: MainLayout,
  //   children: [
  //     {
  //       path: '',
  //       loadComponent: () => import('./feature/candidate-discovery/candidate-discovery.component').then(m => m.CandidateDiscoveryComponent)
  //     }
  //   ]
  // },

  {
    path: 'companies',
    component: MainLayout,
    children: [
      {
        path: '',
        loadComponent: () => import('./feature/company/companies-page/companies-page').then(m => m.CompaniesPageComponent)
      },
      {
        path: 'roles',
        loadComponent: () => import('./feature/company/company-roles/company-roles').then(m => m.CompanyRoles)
      },
      {
        path: 'compensation',
        loadComponent: () => import('./feature/company/company-profile-page/company-profile-page').then(m => m.CompanyProfilePageComponent)
      },

      {
        path: 'reviews/:facilityId',
        loadComponent: () => import('./feature/company/company-reviews-page/company-reviews-page').then(m => m.CompanyReviewsPage)
      }

    ]
  },

  {
    path: 'messages',
    component: MainLayout,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./feature/messages/messages.component').then(m => m.MessagesComponent),
      },
      {
        path: ':threadId',
        loadComponent: () => import('./feature/messages/messages.component').then(m => m.MessagesComponent),
      }
    ]
  },
  {
    path: 'notifications',
    component: MainLayout,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./feature/notifications/notifications-page/notifications-page').then(m => m.NotificationsPageComponent),
      },
    ]
  },

  {
    path: 'roles',
    component: MainLayout,
    children: [
      {
        path: '',
        loadComponent: () => import('./feature/role-directory/role-directory').then(m => m.RoleDirectory),
      },
      {
        path: ':query',
        loadComponent: () => import('./feature/role-salary-entry/role-salary-entry').then(m => m.RoleSalaryEntry)
      }
    ]
  },
  {
    path: 'about',
    component: MainLayout,
    children: [
      {
        path: '',
        loadComponent: () => import('./feature/about-page/about-page').then(m => m.AboutPage)
      }
    ]
  },


  {
    path: 'salaries',
    component: MainLayout,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [

      {
        path: '',
        loadComponent: () => import('./feature/landing/landing').then(m => m.Landing)
      },

      {
        path: 'add',
        loadComponent: () => import('./feature/add-salary-entry/salary-entry-form/salary-entry-form').then(m => m.SalaryEntryForm),

      }
    ]
  },
  {
    path: 'dashboard',
    component: MainLayout,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: 'user-profile',
        children: [
          {
            path: '',
            loadComponent: () => import('./feature/user-profile/user-profile').then(m => m.UserProfile)
          },
          {
            path: 'edit',
            loadComponent: () => import('./feature/user-profile/user-profile-edit/user-profile-edit').then(m => m.UserProfileEditComponent)
          }
        ]
      },
    ]
  },
  {
    path: 'review',
    component: MainLayout,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: 'write',
        loadComponent: () => import('./feature/facility-review/post-review-page/write-review/write-review').then(m => m.WriteReview)
      },
      {
        path: 'edit/:reviewId',
        loadComponent: () => import('./feature/facility-review/edit-review-page/edit-review/edit-review').then(m => m.EditReview)
      }
    ]
  }
];
